import React from "react";
import { Link } from "react-router-dom";

const ProductDevelopment = () => {
  return (
    <>
      <div
        className="container-fluid p-0 banner-section"
        style={{ backgroundImage: "url('img/erp.jpg')" }}
      >
        <div className="overlay"></div>
        <div className="row">
          <div className="col-md-12 mt-5 text-white text-center">
            <h1 className="pt-5 mt-5 ">Product Development</h1>
            <nav>
              <ol className="breadcrumb justify-content-center bg-transparent">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-white text-decoration-none">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Product Development
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-12 mb-4 mb-md-0">
            <img
              src="/img/productidea.jpg"
              width="90%"
              height="50%"
              alt="ERP Implementation Services"
              className="img-fluid rounded-3"
            />
          </div>

          <div className="col-lg-6 col-md-6 col-12">
            <h2 className="fw-bold mb-1">Idea to Implementation</h2>
            <p className="fs-5 py-1">
              This offering includes the complete range of software engineering
              services from building product road-map and architecture,
              prototyping , initial pilot development through to evolution of
              the product through an agreed release plan and maintenance and
              support for the product. One of the options here is to offer the
              customer a BOT (build-operate-transfer ) model where the team
              could be transferred to the customer if they so require once the
              product has matured or when the business has scaled up to the
              point that it would like to invest in an IT team.
            </p>
          </div>
        </div>
      </div>

      <div
        className="container-fuild py-5"
        style={{
          background: "linear-gradient(to top, #f6f4f4, #f5f4f4)",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-12">
              <h2 className="fw-bold mb-1">Product Maintenance</h2>
              <p className="fs-5 py-1">
                This option is for customers who wish to outsource the
                maintenance of internally products after the development phase.
                This is helpful in situations where the customer is looking to
                reduce maintenance costs with overseas teams. A structured
                transition phase where the team acquires product knowledge and
                defines the support/maintenance and change management processes
                would kick off the engagement. The subsequent maintenance phase
                could involve a dedicated team or a shared team with a minimum
                committed annual effort.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-12 mb-4 mb-md-0">
              <img
                src="/img/product.webp"
                width="90%"
                height="50%"
                alt="ERP Implementation Services"
                className="img-fluid rounded-3"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container py-5">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-12 mb-4 mb-md-0">
            <img
              src="/img/productarchitecture.jpg"
              width="90%"
              height="50%"
              alt="ERP Implementation Services"
              className="img-fluid rounded-3"
            />
          </div>

          <div className="col-lg-6 col-md-6 col-12">
            <h2 className="fw-bold mb-1">Product re-architecture</h2>
            <p className="fs-5 py-1">
              Product owners with successful products sometimes see the
              requirement for a new build-from-scratch replacement version to
              replace the current in-use product. DigiOpen Services would then understand
              the new version's drivers and then in collaboration with the
              client team define the product's new architecture, developing
              prototypes where early validation is required. Where required the
              team can also reverse engineer requirements from the legacy
              version or work with customer provided requirements to design and
              implement the new product version
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDevelopment;